import type { Board, BoardResult, EvidenceList, Story, StoryResult } from '@mezha/api'
import { baseApi } from '../baseApi'

export const questsApi = baseApi.injectEndpoints({
  endpoints: b => ({
    story: b.query<Story, void>({ query: () => ({ get: '/api/v1/quests/story' }), providesTags: ['Story'] }),
    evidence: b.query<EvidenceList, void>({ query: () => ({ get: '/api/v1/quests/evidence' }), providesTags: ['Evidence'] }),
    storyInteract: b.mutation<StoryResult, { quest_id: string; object_id: string; choice_id?: string }>({
      query: body => ({ command: '/api/v1/quests/story/interact', body }),
      onQueryStarted: async (_, { queryFulfilled, dispatch }) => {
        const { data } = await queryFulfilled
        dispatch(questsApi.util.upsertQueryData('story', undefined, data.story))
        dispatch(baseApi.util.invalidateTags(['Evidence', 'World', ...(data.battle_id ? (['ActiveBattle'] as const) : [])]))
      },
    }),
    storyClaim: b.mutation<StoryResult, { quest_id: string }>({
      query: body => ({ command: '/api/v1/quests/story/claim', body }),
      onQueryStarted: async (_, { queryFulfilled, dispatch }) => {
        const { data } = await queryFulfilled
        dispatch(questsApi.util.upsertQueryData('story', undefined, data.story))
        dispatch(baseApi.util.invalidateTags(['Hero', 'Inventory', ...(data.reward?.saga.length ? (['Saga'] as const) : [])]))
      },
    }),
    board: b.query<Board, void>({ query: () => ({ get: '/api/v1/quests/board' }), providesTags: ['Board'] }),
    boardCommand: b.mutation<BoardResult, { offer_id: string; action: 'accept' | 'decline' | 'abandon' | 'claim' }>({
      query: ({ offer_id, action }) => ({ command: `/api/v1/quests/board/${offer_id}/${action}` }),
      onQueryStarted: async ({ action }, { queryFulfilled, dispatch }) => {
        const { data } = await queryFulfilled
        dispatch(questsApi.util.upsertQueryData('board', undefined, data.board))
        dispatch(baseApi.util.invalidateTags(action === 'claim' ? ['World', 'Hero', 'Inventory', 'Professions'] : ['World']))
      },
    }),
    boardInteract: b.mutation<BoardResult, { offer_id: string; object_id: string; option?: string }>({
      query: ({ offer_id, ...body }) => ({ command: `/api/v1/quests/board/${offer_id}/interact`, body }),
      onQueryStarted: async (_, { queryFulfilled, dispatch }) => {
        const { data } = await queryFulfilled
        dispatch(questsApi.util.upsertQueryData('board', undefined, data.board))
        dispatch(baseApi.util.invalidateTags(['World', 'Inventory']))
      },
    }),
  }),
})

export const {
  useStoryQuery, useEvidenceQuery, useStoryInteractMutation, useStoryClaimMutation,
  useBoardQuery, useBoardCommandMutation, useBoardInteractMutation,
} = questsApi
